import { Crown } from "lucide-react";

/**
 * "FONDATEUR" badge — only rendered when `show` is truthy.
 * Variants:
 *  - default (light): on white backgrounds
 *  - solid: on dark/hero gradients
 *  - mini: tiny pin next to a name
 */
export default function FounderBadge({ show, variant = "default", className = "" }) {
  if (!show) return null;
  if (variant === "mini") {
    return (
      <span
        title="Fondateur"
        data-testid="founder-badge-mini"
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full bg-jaune ${className}`}
      >
        <Crown className="w-2.5 h-2.5 text-ocean fill-ocean" />
      </span>
    );
  }
  if (variant === "solid") {
    return (
      <span
        data-testid="founder-badge"
        className={`inline-flex items-center gap-1 bg-jaune text-ocean text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-full shadow-sm ${className}`}
      >
        <Crown className="w-3 h-3 fill-ocean" /> Fondateur
      </span>
    );
  }
  return (
    <span
      data-testid="founder-badge"
      className={`inline-flex items-center gap-1 bg-jaune/30 text-ocean text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-full ${className}`}
    >
      <Crown className="w-3 h-3 text-ocean fill-jaune" /> Fondateur
    </span>
  );
}
